import React, { useRef } from 'react';
import { Place } from '../../../../models/Place';
import { checkImage } from '../../../componentUtils';
import {
	BookmarkContainer,
	BookmarkImg,
	BookmarkImgContainer,
	BookmarkInner,
	BookmarkMeta,
	BookmarkTextContainer,
	BookmarkTitle,
} from '../bookmarkStyles';
import { PlaceHelper } from '../../../../models/helpers/Helpers';
import { useHistory } from 'react-router';
import {
	IonIcon,
	IonItemOption,
	IonItemOptions,
	IonItemSliding,
} from '@ionic/react';
import { trash } from 'ionicons/icons';
import {
	BOOKMARK_DEL_PLACE,
	BookmarkReducerAction,
} from '../../../../state/bookmarksSlice';
import { useAppDispatch } from '../../../../state/hooks';
import { createAnimation } from '@ionic/react';

type PlaceBookmarkProps = {
	place: Place;
};
const PlaceBookmark: React.FC<PlaceBookmarkProps> = ({ place }) => {
	const dispatch = useAppDispatch();
	const history = useHistory();

	const gotoPlacePage = () => {
		history.push('/place/' + place.id);
	};

	const container = useRef(null);
	const fadeOutKeyframes = [
		{ offset: 0, opacity: 1 },
		{ offset: 1, opacity: 0 },
	];
	const playAnimation = () => {
		if (container.current !== null) {
			const animation = createAnimation()
				.addElement(container.current)
				.duration(350)
				.keyframes(fadeOutKeyframes)
				.onFinish(removeBookmark);
			animation.play();
		}
	};
	const handleSlide = async (event: any) => {
		const ratio = await event.target.getSlidingRatio();
		if (ratio >= 4) {
			await event.target.open();
			playAnimation();
		}
	};
	const removeBookmark = () => {
		console.log('removing', place.id, place.title);
		dispatch({
			type: BOOKMARK_DEL_PLACE,
			payload: {
				action_id: place.id,
			},
		} as BookmarkReducerAction);
	};

	return (
		// <NavLink to={'/place/' + place.id}>
		<BookmarkContainer ref={container}>
			<IonItemSliding onIonDrag={handleSlide}>
				<BookmarkInner
					onClick={() => {
						gotoPlacePage();
					}}>
					<BookmarkImgContainer>
						<BookmarkImg src={checkImage(place.image)} />
					</BookmarkImgContainer>
					<BookmarkTextContainer>
						<BookmarkTitle>{place.title}</BookmarkTitle>
						<BookmarkMeta>
							{PlaceHelper.generateMetaString(place)}
						</BookmarkMeta>
					</BookmarkTextContainer>
				</BookmarkInner>
				<IonItemOptions>
					<IonItemOption
						color="warning"
						expandable
						onClick={() => {
							playAnimation();
						}}>
						<IonIcon slot="icon-only" icon={trash}></IonIcon>
					</IonItemOption>
				</IonItemOptions>
			</IonItemSliding>
		</BookmarkContainer>
	);
};

export default PlaceBookmark;
